export default "__VITE_ASSET__B08zlPk2__"